const getters = {
  getJwt:(state)=> state.jwt,
  getVerificationJwt:(state) => state.verificationJwt,
}
export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters/getters.js